var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "clip-shadow"
  }, [_vm._t("overflow"), _c('clip-waves', {
    staticClass: "start-layer",
    class: _vm.clipWavesClass,
    style: {
      background: _vm.clipWavesBackground
    },
    attrs: {
      "pad-wave-height": "",
      "offset": _vm.offset
    }
  }, [_vm._t("default")], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }